import errorToast from "../components/toast/errorToast";
import successToast from "../components/toast/successToast";

export const printBillElectron = (order, items) => {
    try {
        window.printer
            .printReceipt({
                ...order,
                products: items,
            })
            .then((res) => {
                if (res.success) {
                    successToast("Printed successfully ✅");
                } else {
                    errorToast("Print failed ❌: " + res.error);
                }
            });
    } catch (error) {
        errorToast("Print failed ❌: " + error);
    }
};

export const printKOTElectron = (products, table_name, parcel) => {
    try {
        window.printer
           .printKot({
            products: products,
            table_name: table_name,
            parcel: parcel,
        })
            .then((res) => {
                if (res.success) {
                    successToast("Printed successfully ✅");
                } else {
                    errorToast("Print failed ❌: " + res.error);
                }
            });
    } catch (error) {
        errorToast("Print failed ❌: " + error);
    }
};
